import React, { createContext, useContext, useEffect, useState } from 'react';
import iconCortPng from 'assets/images/home.png';
import Step1 from './Step1/Step1';
import { Button } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { Entity, Task, TaskResponse, TaskState } from '../../../gql/graphql';
import { useGetTaskResponsesByTask } from '../../../services/task/querys';
import ModalTask from '../components/Organisms/Modals/ModalTask/ModalTask';
import StateTag from '../components/Atoms/Tags/StateTag/StateTag';
import { OpenTaskContext } from '../../../scenes/Private/LoanList/LoanList';

export const TaskContext = createContext<Task | {}>({});
export const EntityContext = createContext<Entity | {}>({});

interface Props {
  task: Task;
  visible?: boolean;
  handlerClose?: Function;
}

const TitleCompany = ({ task, visible, handlerClose }: Props) => {
  const { taskKey, setTaskKey }: any = useContext(OpenTaskContext);

  const { data: taskResponses, reexecute: getTaskResponses } = useGetTaskResponsesByTask({
    variables: { findResponsesByTask: { taskId: task._id } }
  });

  const [isModalTaskVisible, setModalTaskVisible] = useState(false);
  const [step, setStep] = useState(1);
  const [responseStep1, setResponseStep1] = useState<TaskResponse | any>();
  const [entity, setEntity] = useState<Entity | any>();
  const [isReview, setIsReview] = useState(false);

  useEffect(() => {
    if(!isModalTaskVisible && handlerClose)
      handlerClose();
  }, [isModalTaskVisible])

  useEffect(() => {
    setModalTaskVisible(!!visible);
  }, [visible])

  useEffect(() => {
    if (taskKey === 'title_company') {
      setModalTaskVisible(true);
    } else if(!!taskKey)
      setModalTaskVisible(false);
  }, [taskKey]);

  useEffect(() => {
    if (isModalTaskVisible)
      getTaskResponses({ requestPolicy: 'network-only' });
  }, [isModalTaskVisible])

  useEffect(() => {
    if (taskResponses && taskResponses.length > 0) {
      const step1 = taskResponses?.filter((item) => item.step === 1).pop();
      if (step1) setResponseStep1(step1);
      setIsReview(step1?.state === TaskState.Review);
    } else {
      setResponseStep1(undefined);
      setIsReview(false);
    }
  }, [taskResponses]);

  const onHelpDocs = () => {
    console.log('onHelpDocs');
  };

  return (
    <TaskContext.Provider value={task}>
      <EntityContext.Provider value={entity}>
        <ModalTask
          visible={isModalTaskVisible}
          handlerSetVisibile={setModalTaskVisible}
          header={{
            title: <span>UNDERWRITING | TITLE COMPANY</span>,
            actionLeft: (
              isReview ? <StateTag state={TaskState.Review} size="large" /> : <img src={iconCortPng} alt="icon" className="paperPng" />
            ),
            actionRight: (
              <Button
                className="button button-transparent"
                onClick={() => onHelpDocs()}
              >
                <QuestionCircleOutlined />
                Help docs
              </Button>
            )
          }}
          animationDirection="onRight"
          dots={true}
          stepsTotal={1}
          currentStep={step}
          setStep={setStep}
          footer={
            <div className="text-footer mt-20">
              <p className="placeholder">
                My title company is{' '}
                {responseStep1?.metadata?.titleCompany &&
                  <span className="bold-label">
                    {responseStep1?.metadata?.titleCompany}
                  </span>
                }
              </p>
            </div>
          }
        >
          <section className="children AchPaymentForm">
            {step === 1 && (
              <Step1
                closeTask={() => setModalTaskVisible(false)}
              />
            )}
          </section>
        </ModalTask>
      </EntityContext.Provider>
    </TaskContext.Provider>
  );
};
export default TitleCompany;
